import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, FileText, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const ComingSoon = () => {
  const navigate = useNavigate();
  const { category, article } = useParams();

  const categoryNames = {
    'ai': 'AI Features',
    'crm': 'CRM Modules',
    'admin': 'Admin Panel',
    'superadmin': 'SuperAdmin Panel',
    'developer': 'Developer & API'
  };

  const articleTitles = {
    'insights': 'AI Insight Reports',
    'email-generator': 'AI Intro Email Generator',
    'fit-score': 'Understanding the Fit Score',
    'companies-contacts': 'Companies & Contacts',
    'tasks-calendar': 'Tasks and Calendar',
    'notes-activity': 'Notes and Activity History',
    'email-templates': 'Email Templates',
    'user-management': 'User Management',
    'permissions': 'Role Permissions',
    'usage-limits': 'Usage Limits & Plan Entitlements',
    'company-profile': 'Company Profile Setup',
    'tenant-management': 'Tenant Management',
    'plan-upgrades': 'Plan Upgrades',
    'billing': 'Stripe Billing',
    'analytics': 'Platform Analytics',
    'api-tracking': 'API Usage Tracking',
    'ai-config': 'AI Provider Configuration',
    'webhooks': 'Webhook Integrations',
    'auth': 'Authentication & Security'
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <div className="bg-white border-b shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Button
              variant="ghost"
              onClick={() => navigate('/documentation')}
              className="flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Docs
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate('/')}
              className="flex items-center gap-2"
            >
              <Home className="w-4 h-4" />
              Home
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card>
          <CardContent className="pt-12 pb-12 text-center">
            <FileText className="w-16 h-16 text-slate-300 mx-auto mb-6" />
            
            <h1 className="text-3xl font-bold text-slate-900 mb-2">
              {articleTitles[article] || 'Documentation Article'}
            </h1>
            <p className="text-sm text-slate-500 mb-8">
              {categoryNames[category] || 'Documentation'}
            </p>
            
            <div className="max-w-md mx-auto">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
                <h3 className="font-semibold text-slate-900 mb-2">Article Coming Soon</h3>
                <p className="text-slate-700 text-sm mb-4">
                  We're currently writing detailed documentation for this topic. Check back soon for comprehensive guides and tutorials.
                </p>
                <p className="text-slate-600 text-xs">
                  In the meantime, feel free to reach out to our support team if you need assistance.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                  onClick={() => navigate('/documentation')}
                  className="bg-indigo-600 hover:bg-indigo-700"
                >
                  Browse All Documentation
                </Button>
                <Button
                  variant="outline"
                  onClick={() => navigate('/contact')}
                >
                  Contact Support
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ComingSoon;
